module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigBox"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxTitle"
  }, [_vm._v("\n            班级服务使用情况\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "border": "1",
      "id": "tb"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.serviceArr), function(item) {
    return (_vm.params.serviceArr.length > 0) ? _c('tbody', {
      staticClass: "tddd"
    }, _vm._l((item.serviceArr), function(service, index) {
      return _c('tr', [(index == 0) ? _c('td', {
        attrs: {
          "rowSpan": index == 0 ? item.serviceArr.length : 1
        }
      }, [_vm._v(_vm._s(item.userName))]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(service.ServiceTypeName))]), _vm._v(" "), _c('div', {
        staticClass: "buy",
        class: {
          noBuy: !service.IsBuy
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.StartTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.ExpireTime))])])
    })) : _vm._e()
  }), _vm._v(" "), (_vm.params.serviceArr.length == 0) ? _c('tr', {
    staticClass: "tddd"
  }, [_c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")]), _vm._v(" "), _c('td', [_vm._v("——")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom serviceBottom",
    on: {
      "click": _vm.serviceExcel
    }
  }, [_c('button', {
    staticClass: "serviceExcel"
  }, [_c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("导出服务详情")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "thead"
  }, [_c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "240px"
    }
  }, [_vm._v("服务名称")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "190px"
    }
  }, [_vm._v("开通时间")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "190px"
    }
  }, [_vm._v("到期时间")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-030d90a1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/service.vue
// module id = 1153
// module chunks = 1